var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.object.none
    ? _c(
        "div",
        {
          staticClass: "text-container",
          class: { disabled: !_vm.hasPermission },
          on: {
            mouseover: function($event) {
              _vm.hover = true
            },
            mouseleave: function($event) {
              _vm.hover = false
            },
            click: function($event) {
              return _vm.$emit("selectObject", _vm.object)
            }
          }
        },
        [
          _c("strong", [_vm._v(_vm._s(_vm.$tc(_vm.object.type, 1)) + ":")]),
          _vm._v("\n  " + _vm._s(_vm.objectIdentification) + "\n")
        ]
      )
    : _c(
        "div",
        {
          staticClass: "text-container",
          on: {
            click: function($event) {
              return _vm.$emit("selectObject", _vm.object)
            }
          }
        },
        [_c("strong", [_vm._v(_vm._s(_vm.$t("None")))])]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e96d3468", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e96d3468","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectList/ObjectListItem.vue
// module id = null
// module chunks = 